// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"e25d3c39","238":"604eb40b","239":"d5927a67","396":"63655e9d","453":"e8b7f026","455":"cfe4d365","834":"3d009496","857":"b6bed80a","977":"284962be"}[chunkId] + ".chunk.js";
};